import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useSession } from './lib/session';
import Login from './pages/Login';
import Inbox from './pages/Inbox';
import NewTicket from './pages/NewTicket';
import TicketDetail from './pages/TicketDetail';
import Settings from './pages/Settings';
import MailTriage from './pages/MailTriage';
import PortalApp from './portal/PortalApp';
import Changes from './pages/Changes';
import ChangeDetail from './pages/ChangeDetail';
import Contracts from './pages/Contracts';
import ContractDetail from './pages/ContractDetail';
import StatementDetail from './pages/StatementDetail';

export default function App() {
  const { me, loading } = useSession();
  const location = useLocation();

  // Portal del cliente: otra sesión y otra marca, independiente de la de agentes.
  if (location.pathname.startsWith('/t/')) return <PortalApp />;

  if (loading) {
    return <div role="status" className="grid min-h-screen place-items-center text-sm text-muted">Cargando…</div>;
  }
  if (!me) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // Contratos: administrador, líderes de servicio y gestores del servicio.
  const oversight = me.deskRole === 'admin' || me.deskRole === 'team_lead' || Boolean(me.serviceManager);
  return (
    <Routes>
      <Route path="/" element={<Inbox />} />
      <Route path="/tickets/new" element={<NewTicket />} />
      <Route path="/tickets/:number" element={<TicketDetail />} />
      <Route path="/config" element={<Settings />} />
      <Route path="/correo" element={<MailTriage />} />
      {me.modules?.change && <Route path="/cambios" element={<Changes />} />}
      {me.modules?.change && <Route path="/cambios/:number" element={<ChangeDetail />} />}
      {oversight && <Route path="/contratos" element={<Contracts />} />}
      {oversight && <Route path="/contratos/:id" element={<ContractDetail />} />}
      {oversight && <Route path="/contratos/:id/estado/:month" element={<StatementDetail />} />}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
